/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import EventDualSearchPage from './EventDualSearchPage';
import QueryHandler from '../components/misc/QueryHandler';

import { getCustomerKey } from '../utils/browser-storage';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

class EventDualSearchPageQueryRenderer extends Component {
  render() {
    const { match, history, location } = this.props;

    this.snFromUrl = match.params.startnumber;
    this.eventIdFromUrl = match.params.id;
    this.searchDualStartnumberFromUrl = match.params.searchstartnumber;
    this.customerKey = getCustomerKey(this.eventIdFromUrl, this.snFromUrl);
    const queryParams = new URLSearchParams(location.search);
    const code2FA = queryParams.get('code2fa');

    return (
      <QueryHandler
        query={graphql`
          query EventDualSearchPageQueryRendererQuery(
            $eventId: ID!
            $language: String
            $startnumber: ID!
            $searchStartnumber: ID!
            $count: Int!
            $cursor: String
            $secondFactor: String
            $individualPart: String
            $isRecheckPage: Boolean!,
          ) {
            viewer {
              ...EventDualSearchPage_viewer
            }
          }
        `}
        variables={{
          eventId: this.eventIdFromUrl,
          language: match.params.language,
          startnumber: this.snFromUrl !== undefined ? this.snFromUrl : '',
          searchStartnumber: this.searchDualStartnumberFromUrl,
          count: MEDIA_FETCH_COUNT,
          secondFactor: code2FA || this.customerKey,
          individualPart: '',
          isRecheckPage: false,
        }}
        redirectTo={`/event/${this.eventIdFromUrl}`}
        render={props => {
          return (
            <EventDualSearchPage
              viewer={props.viewer}
              snFromUrl={match.params.startnumber}
              searchDualStartnumberFromUrl={match.params.searchstartnumber}
              customerKey={code2FA || this.customerKey} 
              history={history}
              codeSecondFactorForFaceEvent={code2FA}
            />
          );
        }}
      />
    );
  }
}

EventDualSearchPageQueryRenderer.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
};

export default EventDualSearchPageQueryRenderer;
